import { Routes } from "@angular/router";
import { AanvragenStepComponent } from "@zp-components/aanvragen-wizard/aanvragen-step/aanvragen-step.component";
import { AanvragenComponent } from "@zp-components/aanvragen-wizard/aanvragen.component";
import { CheckoutComponent } from "@zp-components/aanvragen-wizard/checkout/checkout.component";
import { AdviceComponent } from "@zp-components/advice/advice.component";
import { QuestionStepComponent } from "@zp-components/question-wizard/question-step/question-step.component";
import { QuestionWizardComponent } from "@zp-components/question-wizard/question-wizard.component";
import { advicePageGuard } from "./advice.guard";
import { WizardStepGuard } from "./wizard-step.guard";

export const routes: Routes = [
  {
    path: "keuzewizard",
    component: QuestionWizardComponent,
    data: { flow: "keuzewizard" },
    children: [
      { path: "", redirectTo: "organisatie", pathMatch: "full" },
      {
        path: "organisatie",
        component: QuestionStepComponent,
        data: { stepId: "step1" },
        canActivate: [],
      },
      {
        path: "mobiliteit",
        component: QuestionStepComponent,
        data: { stepId: "step2" },
        canActivate: [],
      },
      {
        path: "beleid",
        component: QuestionStepComponent,
        data: { stepId: "step3" },
        canActivate: [WizardStepGuard],
      },
      {
        path: "controle-automatisering",
        component: QuestionStepComponent,
        data: { stepId: "step4" },
        canActivate: [WizardStepGuard],
      },
      {
        path: "gebruikersbeheer",
        component: QuestionStepComponent,
        data: { stepId: "step5" },
        canActivate: [WizardStepGuard],
      },
      {
        path: "sso",
        component: QuestionStepComponent,
        data: { stepId: "step6" },
        canActivate: [WizardStepGuard],
      },
      {
        path: "budgettering",
        component: QuestionStepComponent,
        data: { stepId: "step7" },
        canActivate: [WizardStepGuard],
      },
    ],
  },
  {
    path: "advies",
    component: AdviceComponent,
    data: { flow: "advies", isAdvicePage: true },
    canActivate: [advicePageGuard],
  },
  {
    path: "aanvragen",
    component: AanvragenComponent,
    data: { flow: "aanvragen" },
    children: [
      { path: "", redirectTo: "naw", pathMatch: "full" },
      {
        path: "naw",
        component: AanvragenStepComponent,
        data: { stepId: "step1" },
      },
      {
        path: "checkout",
        component: CheckoutComponent,
        data: { stepId: "step2" },
      },
    ],
  },
  { path: "**", redirectTo: "keuzewizard" },
];
